import BackButton from "../../components/CustomButton/BackButton";
import CustomCard from "../../components/CustomCard/CustomCard";
import DetailsHeader from "../../components/Details/DetailsHeader";
import { TITLE_TXT } from "../../constants/constants";
import { capitalizeEntireWord } from "../../helpers/helpers";
import { getDropdownData } from "../../redux/slices/EnqMngtSlice";
import {
  investorDetailedView,
  clearInvErr,
} from "../../redux/slices/investorSlice";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { App, Tabs } from "antd";
import "./Investor.scss";
import InvestorActivityLog from "./Components/InvestorActivityLog.jsx";
import InvestorDetails from "./Components/InvestorDetails.jsx";
import Documents from "./Components/Documents.jsx";

const InvDetails = () => {
  const dispatch = useDispatch();
  const { orgId } = useParams();
  const { notification } = App.useApp();
  const { invDetailedData, editError } = useSelector((state) => state.investor);

  useEffect(() => {
    dispatch(investorDetailedView(orgId));
    dispatch(getDropdownData());
    return () => {
      dispatch(clearInvErr());
    };
  }, [orgId, dispatch]);

  useEffect(() => {
    if (editError) {
      notification.error({
        message: "Error",
        description: editError,
        placement: "topRight",
      });
    }
  }, [editError, dispatch, notification]);

  return (
    <div className="inv-details-container">
      <BackButton />
      <CustomCard>
        <DetailsHeader
          title={capitalizeEntireWord(TITLE_TXT.INV_DETS)}
          name={invDetailedData?.invDetails?.busName}
          id={orgId}
          type="investorPdf"
        />
        <Tabs
          style={{ padding: "10px 30px" }}
          items={[
            {
              key: "1",
              label: "Details",
              children: <InvestorDetails invDetailedData={invDetailedData} />,
            },
            {
              key: "2",
              label: "Documents",
              children: <Documents orgId={orgId} />,
            },
            {
              key: "3",
              label: "Activity Log",
              children: (
                <InvestorActivityLog
                  orgId={orgId}
                  investorName={
                    invDetailedData?.invDetails?.busName ||
                    invDetailedData?.userDetails?.contactName
                  }
                />
              ),
            },
          ]}
        />
      </CustomCard>
    </div>
  );
};

export default InvDetails;
